<template>
  <div class="image-cropper-wrapper">
    <input type="file" class="form-control form-control-sm" accept="image/*" @change="onFileSelected">

    <!-- Modal do Cropper (Bootstrap 5) -->
    <div class="modal fade" :id="modalId" tabindex="-1" aria-hidden="true" ref="cropperModal">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content border-0 shadow-lg" style="border-radius: 16px;">
          
          <div class="modal-header border-0 pb-0 pt-4 px-4">
            <h5 class="modal-title fw-bold text-dark">Recortar Imagem</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="cancelCrop"></button>
          </div>
          
          <div class="modal-body px-4 py-3">
            <div class="img-container bg-dark rounded-3 overflow-hidden d-flex align-items-center justify-content-center mb-3" style="height: 380px; width: 100%;">
              <img ref="imageElement" :src="imageSrc" style="max-width: 100%; max-height: 100%; display: block;" alt="Fonte para recorte" />
            </div>

            <!-- BARRA DE FERRAMENTAS (ZOOM E RESET) -->
            <div class="d-flex justify-content-center align-items-center gap-2 bg-light p-2 rounded-3 border">
              <button type="button" class="btn btn-sm btn-white border shadow-sm" @click="zoomIn" title="Aproximar Zoom">
                <i class="bi bi-zoom-in me-1"></i> Zoom +
              </button>
              <button type="button" class="btn btn-sm btn-white border shadow-sm" @click="zoomOut" title="Afastar Zoom">
                <i class="bi bi-zoom-out me-1"></i> Zoom -
              </button>
              <div class="vr mx-1"></div>
              <button type="button" class="btn btn-sm btn-white border shadow-sm text-secondary" @click="resetCrop" title="Restaurar tamanho original">
                <i class="bi bi-arrow-counterclockwise me-1"></i> Resetar
              </button>
            </div>
          </div>
          
          <div class="modal-footer border-0 px-4 pb-4 pt-0 gap-2">
            <button type="button" class="btn btn-pmg-light px-4" data-bs-dismiss="modal" @click="cancelCrop">
              Cancelar
            </button>
            <button type="button" class="btn btn-pmg-primary px-4" @click="confirmCrop">
              Salvar Recorte
            </button>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageCropper',
  props: {
    aspectRatio: {
      type: Number,
      default: 16 / 9
    }
  },
  data() {
    return {
      imageSrc: null,
      cropperInstance: null,
      bsModal: null,
      modalId: 'cropperModal_' + Math.random().toString(36).substring(2, 9)
    }
  },
  mounted() {
    this.$nextTick(() => {
      const modalEl = this.$refs.cropperModal
      if (modalEl && window.bootstrap) {
        this.bsModal = new window.bootstrap.Modal(modalEl, { backdrop: 'static' })
        
        modalEl.addEventListener('shown.bs.modal', () => {
          this.initCropper()
        })
      }
    }) 
  },
  methods: {
    onFileSelected(event) {
      const file = event.target.files[0]
      if (!file) return

      const reader = new FileReader()
      reader.onload = (e) => {
        this.imageSrc = e.target.result
        
        if (this.bsModal) {
          this.bsModal.show()
        }
      }
      reader.readAsDataURL(file)
      event.target.value = ''
    },
    initCropper() {
      const imageEl = this.$refs.imageElement
      if (!imageEl || !window.Cropper) return

      if (this.cropperInstance) {
        this.cropperInstance.destroy()
      }

      this.cropperInstance = new window.Cropper(imageEl, {
        aspectRatio: this.aspectRatio,
        viewMode: 1,
        autoCropArea: 0.95,
        responsive: true,
        checkCrossOrigin: false
      })
    },
    // Métodos para controle de Zoom e Reset
    zoomIn() {
      if (this.cropperInstance) {
        this.cropperInstance.zoom(0.1)
      }
    },
    zoomOut() {
      if (this.cropperInstance) {
        this.cropperInstance.zoom(-0.1)
      }
    },
    resetCrop() {
      if (this.cropperInstance) {
        this.cropperInstance.reset()
      }
    },
    confirmCrop() {
      if (!this.cropperInstance) {
        console.warn('Instância do Cropper inválida.')
        return
      }

      const canvas = this.cropperInstance.getCroppedCanvas()
      if (canvas) {
        canvas.toBlob((blob) => {
          this.$emit('cropped', blob)
          this.closeModalAndReset()
        }, 'image/jpeg')
      }
    },
    cancelCrop() {
      this.closeModalAndReset()
    },
    closeModalAndReset() {
      if (this.bsModal) {
        this.bsModal.hide()
      }
      if (this.cropperInstance) {
        this.cropperInstance.destroy()
        this.cropperInstance = null
      }
      this.imageSrc = null
    }
  },
  beforeUnmount() {
    if (this.cropperInstance) {
      this.cropperInstance.destroy()
    }
  }
}
</script>